module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADfSURBVHgBrZIBDcIwEEVvBAFImAQcAAqGA4YCJgEHzMFAARIABeBgQwE4KP/Gb9KUW7Im/ORB1/b+XdsTGa81uINZODmR8dLAHFwkMMn4v+Si6go6I3DH7ycowAq8p/g5gHkUdGSgBpW6ETzAjWtqeKaJOPmVbmhBLdGZoyTN0B3oOU+gYnZLmjjL/CBYKMECbOV7N0VQhT9CwypXloHPvuEmHXc0cxzrk/aX6EuJS3uBfTRfcj7shXbIIA4WsRvJWQa1jJdpkCKX0sqm/mKgT5FLunLG9t2mz+MS0ZjqAyOEQ7A+URMvAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/share-2.png
// module id = 2610
// module chunks = 1